import AzureAiFoundryModelsIcon from "../../images/azure/azure-ai-foundry-models.svg";
import AzureAiFoundryAgentServiceIcon from "../../images/azure/azure-ai-foundry-agent-service.svg";
import AzureAiFoundryApplicationIcon from "../../images/azure/azure-ai-foundry-application.svg";
import AzureAiFoundryProjectIcon from "../../images/azure/azure-ai-foundry-project.svg";
import AzureAiSearchIcon from "../../images/azure/azure-ai-search.svg";
import AzureAiServicesIcon from "../../images/azure/azure-ai-services.svg";
import AzureApiManagementIcon from "../../images/azure/azure-api-management.svg";
import AzureAppConfigurationIcon from "../../images/azure/azure-app-configuration.svg";
import AzureAppServiceIcon from "../../images/azure/azure-app-service.svg";
import AzureApplicationGatewayIcon from "../../images/azure/azure-application-gateway.svg";
import AzureApplicationInsightsIcon from "../../images/azure/azure-application-insights.svg";
import AzureAksNetworkPolicyIcon from "../../images/azure/azure-aks-network-policy.svg";
import AzureArcIcon from "../../images/azure/azure-arc.svg";
import AzureBackupCenterIcon from "../../images/azure/azure-backup-center.svg";
import AzureBastionIcon from "../../images/azure/azure-bastion.svg";
import AzureBatchIcon from "../../images/azure/azure-batch.svg";
import AzureCommunicationServicesIcon from "../../images/azure/azure-communication-services.svg";
import AzureContainerAppsIcon from "../../images/azure/azure-container-apps.svg";
import AzureContainerRegistryIcon from "../../images/azure/azure-container-registry.svg";
import AzureCosmosDbIcon from "../../images/azure/azure-cosmos-db.svg";
import AzureDataFactoryIcon from "../../images/azure/azure-data-factory.svg";
import AzureDatabricksIcon from "../../images/azure/azure-databricks.svg";
import AzureDefenderForCloudIcon from "../../images/azure/azure-defender-for-cloud.svg";
import AzureDevOpsIcon from "../../images/azure/azure-devops.svg";
import AzureDdosProtectionIcon from "../../images/azure/azure-ddos-protection.svg";
import AzureDnsZonesIcon from "../../images/azure/azure-dns-zones.svg";
import AzureEventGridIcon from "../../images/azure/azure-event-grid.svg";
import AzureEventHubsIcon from "../../images/azure/azure-event-hubs.svg";
import AzureExpressRouteIcon from "../../images/azure/azure-expressroute.svg";
import AzureFirewallIcon from "../../images/azure/azure-firewall.svg";
import AzureFrontDoorIcon from "../../images/azure/azure-front-door.svg";
import AzureFunctionsIcon from "../../images/azure/azure-functions.svg";
import AzureIotCentralIcon from "../../images/azure/azure-iot-central.svg";
import AzureIotHubIcon from "../../images/azure/azure-iot-hub.svg";
import AzureKeyVaultIcon from "../../images/azure/azure-key-vault.svg";
import AzureLoadBalancerIcon from "../../images/azure/azure-load-balancer.svg";
import AzureLogAnalyticsIcon from "../../images/azure/azure-log-analytics.svg";
import AzureLogicAppsIcon from "../../images/azure/azure-logic-apps.svg";
import AzureMachineLearningIcon from "../../images/azure/azure-machine-learning.svg";
import AzureManagedCassandraIcon from "../../images/azure/azure-managed-cassandra.svg";
import AzureManagedFileSharesIcon from "../../images/azure/azure-managed-file-shares.svg";
import AzureManagedIdentitiesIcon from "../../images/azure/azure-managed-identities.svg";
import AzureMonitorIcon from "../../images/azure/azure-monitor.svg";
import AzureMySqlIcon from "../../images/azure/azure-mysql.svg";
import AzureNotificationHubsIcon from "../../images/azure/azure-notification-hubs.svg";
import AzureOpenAiIcon from "../../images/azure/azure-openai.svg";
import AzurePolicyIcon from "../../images/azure/azure-policy.svg";
import AzurePostgreSqlIcon from "../../images/azure/azure-postgresql.svg";
import AzurePrivateLinkIcon from "../../images/azure/azure-private-link.svg";
import AzurePublicIpIcon from "../../images/azure/azure-public-ip.svg";
import AzureRecoveryServicesVaultIcon from "../../images/azure/azure-recovery-services-vault.svg";
import AzureRedHatOpenShiftIcon from "../../images/azure/azure-red-hat-openshift.svg";
import AzureResourceGroupsIcon from "../../images/azure/azure-resource-groups.svg";
import AzureRouteTablesIcon from "../../images/azure/azure-route-tables.svg";
import AzureServiceBusIcon from "../../images/azure/azure-service-bus.svg";
import AzureServiceFabricIcon from "../../images/azure/azure-service-fabric.svg";
import AzureSentinelIcon from "../../images/azure/azure-sentinel.svg";
import AzureSqlDatabaseIcon from "../../images/azure/azure-sql-database.svg";
import AzureSqlManagedInstanceIcon from "../../images/azure/azure-sql-managed-instance.svg";
import AzureSpringAppsIcon from "../../images/azure/azure-spring-apps.svg";
import AzureStorageIcon from "../../images/azure/azure-storage.svg";
import AzureStreamAnalyticsIcon from "../../images/azure/azure-stream-analytics.svg";
import AzureSynapseAnalyticsIcon from "../../images/azure/azure-synapse-analytics.svg";
import AzureTrafficManagerIcon from "../../images/azure/azure-traffic-manager.svg";
import AzureVirtualMachineScaleSetsIcon from "../../images/azure/azure-virtual-machine-scale-sets.svg";
import AzureVirtualMachinesIcon from "../../images/azure/azure-virtual-machines.svg";
import AzureVirtualNetworkIcon from "../../images/azure/azure-virtual-network.svg";
import AzureVmwareSolutionIcon from "../../images/azure/azure-vmware-solution.svg";
import AzureWebApplicationFirewallIcon from "../../images/azure/azure-web-application-firewall.svg";
import AzureCacheForRedisIcon from "../../images/azure/azure-cache-for-redis.svg";
import AzureKubernetesServiceIcon from "../../images/azure/azure-kubernetes-service.svg";
const AZURE_PRODUCT_ICON_MATCHES = [
    [/\b(redis|cache)\b/, AzureCacheForRedisIcon],
    [/\b(foundry agent service|foundry agent)\b/, AzureAiFoundryAgentServiceIcon],
    [/\b(foundry projects?)\b/, AzureAiFoundryProjectIcon],
    [/\b(foundry applications?)\b/, AzureAiFoundryApplicationIcon],
    [/\b(red hat openshift|aro)\b/, AzureRedHatOpenShiftIcon],
    [/\b(container apps?)\b/, AzureContainerAppsIcon],
    [/\b(aks network policy)\b/, AzureAksNetworkPolicyIcon],
    [/\b(aks|kubernetes|container services?)\b/, AzureKubernetesServiceIcon],
    [/\b(container registr(?:y|ies)|acr)\b/, AzureContainerRegistryIcon],
    [/\b(vm scale sets?|virtual machine scale sets?|vmss)\b/, AzureVirtualMachineScaleSetsIcon],
    [/\b(virtual machines?|vm)\b/, AzureVirtualMachinesIcon],
    [/\b(batch accounts?|azure batch)\b/, AzureBatchIcon],
    [/\b(service fabric)\b/, AzureServiceFabricIcon],
    [/\b(spring apps?)\b/, AzureSpringAppsIcon],
    [/\b(function apps?|azure functions?)\b/, AzureFunctionsIcon],
    [/\b(app services?|web apps?)\b/, AzureAppServiceIcon],
    [/\b(managed file shares?)\b/, AzureManagedFileSharesIcon],
    [/\b(blob|file shares?|storage accounts?|storage)\b/, AzureStorageIcon],
    [/\b(postgresql|postgres)\b/, AzurePostgreSqlIcon],
    [/\b(mysql)\b/, AzureMySqlIcon],
    [/\b(managed cassandra|cassandra)\b/, AzureManagedCassandraIcon],
    [/\b(sql managed instance)\b/, AzureSqlManagedInstanceIcon],
    [/\b(cosmos db|cosmos)\b/, AzureCosmosDbIcon],
    [/\b(sql|database)\b/, AzureSqlDatabaseIcon],
    [/\b(key vaults?)\b/, AzureKeyVaultIcon],
    [/\b(web application firewall|waf)\b/, AzureWebApplicationFirewallIcon],
    [/\b(firewall|waf)\b/, AzureFirewallIcon],
    [/\b(ddos)\b/, AzureDdosProtectionIcon],
    [/\b(private link|private endpoint)\b/, AzurePrivateLinkIcon],
    [/\b(bastion)\b/, AzureBastionIcon],
    [/\b(dns zones?|azure dns)\b/, AzureDnsZonesIcon],
    [/\b(traffic manager)\b/, AzureTrafficManagerIcon],
    [/\b(expressroute|express route)\b/, AzureExpressRouteIcon],
    [/\b(public ip|ip address)\b/, AzurePublicIpIcon],
    [/\b(route tables?)\b/, AzureRouteTablesIcon],
    [/\b(application gateways?|app gateways?)\b/, AzureApplicationGatewayIcon],
    [/\b(front door|cdn)\b/, AzureFrontDoorIcon],
    [/\b(load balancers?)\b/, AzureLoadBalancerIcon],
    [/\b(virtual networks?|vnet|network infrastructure|network)\b/, AzureVirtualNetworkIcon],
    [/\b(azure vmware|vmware solution)\b/, AzureVmwareSolutionIcon],
    [/\b(api management|apim)\b/, AzureApiManagementIcon],
    [/\b(service bus)\b/, AzureServiceBusIcon],
    [/\b(event grid)\b/, AzureEventGridIcon],
    [/\b(event hubs?)\b/, AzureEventHubsIcon],
    [/\b(logic apps?)\b/, AzureLogicAppsIcon],
    [/\b(app configuration)\b/, AzureAppConfigurationIcon],
    [/\b(notification hubs?)\b/, AzureNotificationHubsIcon],
    [/\b(communication services?)\b/, AzureCommunicationServicesIcon],
    [/\b(iot central)\b/, AzureIotCentralIcon],
    [/\b(iot hub)\b/, AzureIotHubIcon],
    [/\b(stream analytics)\b/, AzureStreamAnalyticsIcon],
    [/\b(data factory)\b/, AzureDataFactoryIcon],
    [/\b(synapse)\b/, AzureSynapseAnalyticsIcon],
    [/\b(databricks)\b/, AzureDatabricksIcon],
    [/\b(openai)\b/, AzureOpenAiIcon],
    [/\b(foundry)\b/, AzureAiFoundryModelsIcon],
    [/\b(machine learning|azure ml)\b/, AzureMachineLearningIcon],
    [/\b(ai search|cognitive search|azure search)\b/, AzureAiSearchIcon],
    [/\b(cognitive services?|ai services?)\b/, AzureAiServicesIcon],
    [/\b(application insights|app insights)\b/, AzureApplicationInsightsIcon],
    [/\b(log analytics)\b/, AzureLogAnalyticsIcon],
    [/\b(azure monitor|monitor)\b/, AzureMonitorIcon],
    [/\b(devops|azure devops)\b/, AzureDevOpsIcon],
    [/\b(defender for cloud|azure defender)\b/, AzureDefenderForCloudIcon],
    [/\b(sentinel)\b/, AzureSentinelIcon],
    [/\b(backup center)\b/, AzureBackupCenterIcon],
    [/\b(recovery services?|backup vault|azure backup)\b/, AzureRecoveryServicesVaultIcon],
    [/\b(managed identities?|entra managed identities?)\b/, AzureManagedIdentitiesIcon],
    [/\b(resource groups?)\b/, AzureResourceGroupsIcon],
    [/\b(azure policy|policy)\b/, AzurePolicyIcon],
    [/\b(azure arc|arc machines?)\b/, AzureArcIcon],
];
export const getAzureProductIconSource = (productName) => {
    const normalizedProductName = productName.toLowerCase();
    const matchingIcon = AZURE_PRODUCT_ICON_MATCHES.find(([pattern]) => pattern.test(normalizedProductName));
    return matchingIcon === null || matchingIcon === void 0 ? void 0 : matchingIcon[1];
};
